module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('content-top-header', {
    staticClass: "black-theme"
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', _vm._l((_vm.tabs), function(tab) {
    return _c('li', {
      key: tab.id,
      staticClass: "nav-li",
      class: [{
        active: _vm.isActiveTab(tab.id)
      }, ("nav-" + (tab.id))],
      attrs: {
        "href": ("#" + (tab.id))
      }
    }, [_c('label', {
      staticClass: "nav-label",
      on: {
        "click": function($event) {
          _vm.onTab(tab.id)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.title) + "\n          ")])])
  }))])], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content margin-top-header"
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    staticClass: "min-100",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-4 pt-4",
    attrs: {
      "xs12": "",
      "sm7": "",
      "order-section": ""
    }
  }, [_c('div', {
    staticClass: "mb-4 main-heading"
  }, [_vm._v("Order #: "), _c('b', [_vm._v(_vm._s(_vm.order_detail.id))])]), _vm._v(" "), _c('div', {
    staticClass: "order-container"
  }, _vm._l((_vm.order_detail.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "order-item"
    }, [_c('div', {
      staticClass: "order-content-section pa-0",
      attrs: {
        "sm12": ""
      }
    }, [_c('div', {
      staticClass: "product-cover-image"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'SingleProduct',
          params: {
            id: item.product.id
          }
        }
      }
    }, [_c('activity-product-card', {
      attrs: {
        "object": item.product,
        "price-show": false
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content"
    }, [_c('div', {
      staticClass: "product-content-row"
    }, [_c('div', {
      staticClass: "product-name"
    }, [_c('router-link', {
      attrs: {
        "to": "#"
      }
    }, [_c('span', {
      staticClass: "black--text"
    }, [_vm._v("\n                          " + _vm._s(item.product.name) + " | " + _vm._s(item.product_variant.name) + "\n                        ")])])], 1), _vm._v(" "), _c('div', {
      staticClass: "product-content-row justify-space-between pt-0"
    }, [_c('div', [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": ("/" + (item.product.merchant.slug))
      }
    }, [_vm._v("\n                          " + _vm._s(item.product.merchant.username) + "\n                        ")])], 1)]), _vm._v(" "), _c('label', {
      staticClass: "product-price"
    }, [_vm._v("\n                      Quantity: "), _c('b', [_vm._v(_vm._s(item.quantity))])])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
      staticClass: "product-action-row justify-space-between"
    }, [_c('label', {
      staticClass: "product-price"
    }, [_vm._v("\n                    $" + _vm._s(_vm._f("formatNumber")(item.price)) + "\n                  ")])])], 1)])])
  })), _vm._v(" "), _c('div', {
    staticClass: "orders-status-section"
  }, [_c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.subTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("\n                  $" + _vm._s(_vm._f("formatNumber")(_vm.shippingTotal)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Sales Tax")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.taxTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "status-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Stripe Fee")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.stripeFee)))])]), _vm._v(" "), _c('div', {
    staticClass: "total-row"
  }, [_c('label', {
    staticClass: "status-title"
  }, [_vm._v("Total")]), _vm._v(" "), _c('label', {
    staticClass: "status-title value"
  }, [_c('span', [_vm._v("USD")]), _vm._v("$" + _vm._s(_vm._f("formatNumber")(_vm.total)))])])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "orders-section-container px-5 pt-4",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "title mb-2"
  }, [_vm._v("Shipment status")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Sellers have 21 days to ship your items")])]), _vm._v(" "), _c('div', {
    staticClass: "pendingDiv"
  }, [_c('div', {
    staticClass: "bold"
  }, [_vm._v("\n                " + _vm._s(this.order_status[_vm.order_detail.status]) + "\n              ")]), _vm._v(" "), (_vm.order_detail.status == 'order_pending') ? _c('div', [_vm._v(_vm._s(_vm.remainingDaysForShipment()) + " days left to ship or you will receive an automatic refund")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.order_detail.items), function(item) {
    return _c('div', {
      staticClass: "trackDiv mt-3"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("\n                    Shipped\n                  ")]), _vm._v("\n                  with "), _c('span', {
      staticClass: "bold"
    }, [_vm._v("\n                    " + _vm._s(item.tracking_site) + "\n                  ")])]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "bold"
    }, [_vm._v("\n                  Tracking:\n                ")]), _vm._v(" " + _vm._s(item.tracking_number) + "\n              ")]), _vm._v(" "), _c('div', [_c('v-btn', {
      staticClass: "green-btn mt-2"
    }, [_vm._v("Track order")])], 1)])
  })], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ad08a0d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sell/orderdetail.vue
// module id = 1714
// module chunks = 180